import BomRematchData from './BomRematchData/BomRematchData';
import BomRematchTable from './BomRematchData/BomRematchTable';
import System from "../../../helper/system";
import React, { useEffect } from "react";
import { useBOMStore } from 'src/hooks/bom';
import ShowAlert from 'src/component/Global/ShowAlert';

const bomId = System.getParams().bomId;

const BomRematchListing = (props) => {
    const [{ }, { fetch_static_columns, fetch_saved_preference_by_bom_id, fetch_saved_columns_data_by_bom_id }, { }] = useBOMStore();

    useEffect(() => {
        async function fetchHere() {
            if (bomId) {
                await fetch_static_columns();
                await fetch_saved_preference_by_bom_id({ bomId });
                await fetch_saved_columns_data_by_bom_id({ bomId });
            } else {
                window.history.back()
            }
        }

        fetchHere()
    }, []);
    return (
        <>
            <div className="container">
                <ShowAlert />
                <BomRematchData />
                <BomRematchTable />
            </div>

        </>
    );
}

export default BomRematchListing;